// ConditiiComponent.jsx — FULL (unique classes + same design language as srTerms_/srReg_/srReset_)
import React, { useEffect, useState } from "react";
import api from "../../api/http";
import "../../styles/about/ConditiiComponent.css";

const ConditiiComponent = () => {
  const [conditions, setConditions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errMsg, setErrMsg] = useState("");

  useEffect(() => {
    let cancelled = false;

    const fetchConditions = async () => {
      setLoading(true);
      setErrMsg("");

      try {
        const res = await api.get("/about/conditi/");
        const data = res.data;

        const list = Array.isArray(data)
          ? data
          : Array.isArray(data?.results)
          ? data.results
          : [];

        if (!cancelled) setConditions(list);
      } catch (error) {
        console.error("Error fetching conditions:", error);
        if (!cancelled) {
          setErrMsg(error?.response?.data?.detail || error?.message || "Eroare la încărcare");
          setConditions([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchConditions();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="srCond_page">
      <div className="srCond_wrap">
        <div className="srCond_card">
          <div className="srCond_header">
            <h2 className="srCond_title">Condiții</h2>
            <p className="srCond_subtitle">Reguli și informații importante</p>
          </div>

          {loading && <p className="srCond_state">Se încarcă...</p>}

          {!loading && errMsg && (
            <p className="srCond_state srCond_stateErr">{errMsg}</p>
          )}

          {!loading && !errMsg && (
            <div className="srCond_list">
              {conditions.map((condition, index) => {
                const descrierii = Array.isArray(condition?.descrierii)
                  ? condition.descrierii
                  : [];

                return (
                  <div className="srCond_item" key={condition.id}>
                    <h3 className="srCond_itemTitle">
                      {`${romanize(index + 1)}. ${condition.titlu}`}
                    </h3>

                    {condition.text ? (
                      <p className="srCond_text">{condition.text}</p>
                    ) : null}

                    {descrierii.length > 0 ? (
                      <ol className="srCond_descList">
                        {descrierii.map((d, idx) => (
                          <li
                            className="srCond_descItem"
                            key={d.id ?? `${condition.id}-${idx}`}
                          >
                            <span className="srCond_badge">{`${idx + 1})`}</span>
                            <span className="srCond_descText">
                              {d.text ?? d.descrierea ?? ""}
                            </span>
                          </li>
                        ))}
                      </ol>
                    ) : (
                      <p className="srCond_empty">Nu există descrieri.</p>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConditiiComponent;

function romanize(number) {
  const romanNumerals = {
    1: "I",
    2: "II",
    3: "III",
    4: "IV",
    5: "V",
    6: "VI",
    7: "VII",
    8: "VIII",
    9: "IX",
    10: "X",
  };

  return romanNumerals[number] || number.toString();
}